//===============================================================================================================
// #1 - Base Imports
//===============================================================================================================
import React from 'react';
// import Switch from '@material-ui/core/Switch';

//===============================================================================================================
// #2 - Import * Redux
//===============================================================================================================
import { connect } from 'react-redux';

//===============================================================================================================
// #4 - Import * UI Components
//===============================================================================================================
import { Menu, MenuItem as Item } from '../../../components/ui/menu';
import HeaderPage from "../../../components/patterns/subpages/header";

//===============================================================================================================
// #4 - Import * Font Awesome Icons
//===============================================================================================================
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import { WrapperMenu } from "./styles";

function UserMenu({ website }, props) {

    // * States
    // const [state, setState] = React.useState({
    //     checkedA: true,
    //     checkedB: false,
    // });


    // // const handleChange = (event) => {
    // //     setState({ ...state, [event.target.name]: event.target.checked });
    // // };

    return (
        <>

            <div className="MobileUserMenu" style={{ color: `${props => props.theming[website]?.button.color}` }}>

                <HeaderPage>
                    Olá, Bem-vindo
                </HeaderPage>

                <WrapperMenu>

                    <Menu title="menu">

                        <Item
                            link={"/ofertas-ativas"}
                            withArrowIcon={true}
                            icon={<Icon icon={["far", "tags"]} color={'red'} />}
                            title="Ofertas"
                            subtitle=""
                            svgIconColor={props => props.theme[website]?.colors.menu.icon}
                        />
                        <Item
                            link={"/parceiros"}
                            withArrowIcon={true}
                            icon={<Icon icon={["far", "store"]} />}
                            title="Parceiros"
                            subtitle="Veja todos os parceiros"
                            svgIconColor={props => props.theme[website]?.colors.menu.icon}
                        />

                        {/* <Item link={"#!!"} withArrowIcon={true} icon={<Icon icon={["far", "scroll"]} />} title="Folheto" subtitle="Confira todas as ofertas" /> */}

                    </Menu>
                    {/* 
                    <Menu title="configurações">

                        <Item link={"#!!"} withArrowIcon={true} icon={<Icon icon={["far", "shield-alt"]} />} title="Privacidade" subtitle="Privacidade de dados" />

                        <Item link="#!!" icon={<Icon icon={["far", "map-marker-alt"]} />} withArrowIcon={false} title="Localização" subtitle="Ative ou desative sua localização" >

                            <Switch
                                checked={state.checkedA}
                                onChange={handleChange}
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </Item>
                        <Item link="#!!" icon={<Icon icon={["far", "engine-warning"]} />} withArrowIcon={false} title="Notificações" subtitle="Ative ou desative as notificações" >

                            <Switch
                                checked={state.checkedB}
                                onChange={handleChange}
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </Item>


                    </Menu> */}

                    <Menu title="serviços">

                        <Item
                            link={"/ajuda"}
                            withArrowIcon={true}
                            icon={<Icon icon={["far", "question-circle"]} />}
                            title="Ajuda"
                            subtitle="Visite nossa central de ajuda"
                            svgIconColor={props => props.theme[website]?.colors.menu.icon}
                        />

                        <Item
                            link={"/terms"}
                            paramReadOnly={'readonly=true'}
                            withArrowIcon={true} icon={<Icon icon={["far", "file-alt"]} />}
                            title="Termos e condições"
                            subtitle="Acesse os termos e condições"
                            svgIconColor={props => props.theme[website]?.colors.menu.icon}
                        />

                    </Menu>
                </WrapperMenu>

            </div>
        </>
    )
}

const mapStateToProps = state => {
    return {
        scamber: state.scamberReducer.scamber,
        balance: state.balanceReducer.balance,
        cart: state.cartReducer.cart,
        site_properties: state.websiteReducer.site_properties,
        website: state.websiteReducer.website
    }
}

export default connect(mapStateToProps, {})(UserMenu);